import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="flowbite-tabs"
export default class extends Controller {
  static targets = ["tab", "panel"]
  // storageKey opts in to remembering the active tab across full-page reloads (e.g. a filter form
  // that resubmits via GET). Omit the value to get the original no-persistence behavior.
  static values = { storageKey: { type: String, default: "" } }

  connect() {
    const initialTab = this.findSavedTab() || this.element.querySelector('[aria-selected="true"]')
    if (initialTab) {
      this.activateTab(initialTab, { persist: false })
    }
  }

  findSavedTab() {
    if (!this.storageKeyValue) return null

    const savedTargetId = sessionStorage.getItem(this.storageKeyValue)
    if (!savedTargetId) return null

    return this.element.querySelector(`[data-tabs-target="${savedTargetId}"]`)
  }

  switch(event) {
    event.preventDefault()
    this.activateTab(event.currentTarget, { persist: true })
  }

  // Single source of truth for "this tab is now active" - updates styling and panel visibility
  // together, and optionally persists the choice, rather than mutating aria-selected and having a
  // separate step re-derive panel visibility from it.
  activateTab(button, { persist }) {
    const targetId = button.getAttribute('data-tabs-target')
    const targetPanel = this.element.querySelector(targetId)
    if (!targetPanel) return

    this.hideAllPanels()
    this.deactivateAllTabs()

    targetPanel.classList.remove('hidden')
    button.classList.remove('text-gray-500', 'border-transparent', 'hover:text-gray-600', 'hover:border-gray-300')
    button.classList.add('text-frankly-bluegreen', 'border-frankly-bluegreen')
    button.setAttribute('aria-selected', 'true')

    if (persist && this.storageKeyValue) {
      sessionStorage.setItem(this.storageKeyValue, targetId)
    }
  }

  hideAllPanels() {
    const panels = this.element.querySelectorAll('[role="tabpanel"]')
    panels.forEach(panel => {
      panel.classList.add('hidden')
    })
  }

  deactivateAllTabs() {
    const tabs = this.element.querySelectorAll('[role="tab"]')
    tabs.forEach(tab => {
      tab.classList.remove('text-frankly-bluegreen', 'border-frankly-bluegreen')
      tab.classList.add('text-gray-500', 'border-transparent', 'hover:text-gray-600', 'hover:border-gray-300')
      tab.setAttribute('aria-selected', 'false')
    })
  }
}
